module.exports = __webpack_public_path__ + "static/img/er_code_weixin.6ef9fa53.jpg";